/** Shared sport badge + tab styling for Lockbox UI — derives from sportTheme (WI-3). */
import { getSportTheme, normalizeSportKey } from '../constants/sportTheme';

export const UPCOMING_TAB = 'Upcoming';

const TAB_BASE =
  'px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest border transition-colors';

/** Dark-theme badge classes per sport — same theme, distinct colors. */
export function getSportBadgeClasses(sport) {
  return getSportTheme(sport).accent.badge;
}

/** Tab button classes per sport — match badge colors; Upcoming uses neutral. */
export function getSportTabClasses(sport, isActive) {
  const key = normalizeSportKey(sport);
  if (key === UPCOMING_TAB.toUpperCase()) {
    return isActive
      ? `${TAB_BASE} bg-gray-500/30 text-gray-200 border-gray-500/50 shadow-[0_4px_12px_rgba(0,0,0,0.3)]`
      : `${TAB_BASE} bg-black/40 border-gray-800 text-gray-400 hover:border-gray-600 hover:text-gray-300`;
  }
  const { accent } = getSportTheme(sport);
  return isActive ? accent.tabActive : accent.tabInactive;
}
